<!-- Do not change this file. -->

<template>
  <div class="alert alert-warning text-dark text-start p-0">
    <div class="fw-bold h5 text-uppercase pt-2 ps-2">(Vuex) Settings</div>
    <table class="table table-striped m-0 p-0" aria-label="(Vuex) Env">
      <tbody>
        <tr>
          <th>Public Key</th>
          <td>{{ publicKey }}</td>
        </tr>
        <tr>
          <th>Use Auth</th>
          <td>{{ useAuth }}</td>
        </tr>
        <tr>
          <th>Using Datastore</th>
          <td>{{ useDatastore }}</td>
        </tr>
        <tr>
          <th>Using Landing Page</th>
          <td>{{ useLandingPage }}</td>
        </tr>
        <tr>
          <th>Debug Mode</th>
          <td>{{ isDebugMode }}</td>
        </tr>

        <tr>
          <th>Use Navbar</th>
          <td>{{ useNavbar }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/* Do not change this file. */

import { mapGetters } from "vuex";

export default {
  name: "DebugEnv",
  computed: {
    ...mapGetters([
      "useAuth",
      "useDatastore",
      "isDebugMode",
      "publicKey",
      "useNavbar",
      "useLandingPage"
    ])
  }
};
</script>
